@if (!noFieldReference){
<div class="form-check form-switch mb-2 d-flex align-items-center gap-2">
    <input
      class="form-check-input slider"
      type="checkbox"
      id="freeTextToggle"
      [(ngModel)]="freeText"
    />
    <label class="form-check-label" for="freeTextToggle">
      {{"ENTER_CUSTOM_PATH" | translate}}
    </label>
  </div>
  }
  
  @if (freeText || noFieldReference) {
    <input
      type="text"
      class="form-control"
      [placeholder]="'Enter custom path...'"
      [(ngModel)]="selectedPath"
      (ngModelChange)="selectedPathChange.emit($event)" />
  } @else {
    <lib-gung-input-multi-select
      [optionsList]="fieldReferences"
      (selectedValues)="onSelect($event)"
      [singleSelection]="true"
      previewField="displayName"
    >
    </lib-gung-input-multi-select>
  }
  